import { IoIosImages, IoIosList } from "react-icons/io";
import { MdEdit } from "react-icons/md";
import { Link, useLocation } from "react-router-dom";

export default function Sidebar({ onResetForm }) {

    const location = useLocation();
    const isActive = (path) => location.pathname === path;

    const handleGenerateAdClick = () => {
        if (onResetForm) {
            onResetForm();
        }
    };

  return (
    <>
    <aside className="w-[240px] px-5 flex flex-col left-sidebar border-r border-gray-200">
        <div className='sticky-block'>
        <div className="flex items-center gap-3 mb-3">
            <img src="/IrisLogo.svg" alt="Ultra Iris Logo" className="ultra-iris-logo" />
        </div>
        <p className="mb-5 text-gray-600 text-sm leading-tight">
            AI Based Creative Generator
        </p>

        <ul>
            <li
            className={`menu-item ${
                isActive("/") ? "active" : ""
            }`}
            >
                <Link className="menu-item-btn" to="/" onClick={handleGenerateAdClick}>
                    <i className="icon">
                    <IoIosImages />
                    </i>
                    <span className="text">Generate Ad</span>
                </Link>
            </li>
            <li
            className={`menu-item ${
                isActive("/improvements") ? "active" : ""
            }`}
            >
                <Link className="menu-item-btn" to="/improvements">
                    <i className="icon">
                    <MdEdit />
                    </i>
                    <span className="text">Improvements</span>
                </Link>
            </li>
            {/* Temporarily hidden - Video Generator */}
            {/* <li
            className={`menu-item ${
                isActive("/video-generation") ? "active" : ""
            }`}
            >
                <Link className="menu-item-btn" to="/video-generation">
                    <i className="icon">
                    <FiVideo />
                    </i>
                    <span className="text">Video Generator</span>
                </Link>
            </li> */}
            <li
            className={`menu-item ${
                isActive("/creative-history") ? "active" : ""
            }`}
            >
                <Link className="menu-item-btn" to="/creative-history">
                    <i className="icon">
                    <IoIosList />
                    </i>
                    <span className="text">Ad History</span>
                </Link>
            </li>
        </ul>
        </div>
    </aside>
    </>
  )
}
